export enum SelectionMode {
	None = 0,
	Single,
	Multiple
}